module.exports = __webpack_public_path__ + "img/26_170.42dd9ac6.png";